import { render } from "./SocialIcons.vue?vue&type=template&id=6e4ce774"
import script from "./SocialIcons.vue?vue&type=script&lang=js"
export * from "./SocialIcons.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__